import "./GarageDoorCableRepairSydney.module.css";
import Header from "@/reusable_sections/Header";
import GarageHero from "./sections/GarageHero";
import GarageIntro from "./sections/GarageIntro";
import Cableservices from "./sections/Cableservices";
import Garage from "./sections/Garage";
import GarageProcess from "./sections/GarageProcess";
import GarageWhyUs from "./sections/GarageWhyUs";
import GarageComparison from "./sections/GarageComparison";
import GarageTestimonials from "./sections/GarageTestimonials";
import GarageFaq from "./sections/GarageFaq";
import GarageCta from "./sections/GarageCta";
import ServiceAreaExplorer from "./sections/ServiceAreaExplorer";
import CableFooter from "./sections/CableFooter";
export default function GarageDoorCableRepairSydneyPage() {
  return <div>
      <Header />
      <GarageHero />
      <GarageIntro />
      <Cableservices />
      <Garage />
      <GarageProcess />
      <GarageWhyUs />
      <GarageComparison />
      <GarageTestimonials />
      <GarageFaq />
      <GarageCta />
      <ServiceAreaExplorer />
      <CableFooter />
    </div>;
}